import { Component, OnInit } from '@angular/core';
import { NotificationsConfiguration } from 'src/app/domain/notifications-configuration';
import { ConfigurationService } from '../configuration.service';
import { ConnectivityService } from 'src/app/connectivity/connectivity.service';
import { MessageService } from 'src/app/message/message.service';
import { Severity } from 'src/app/message/Severity';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

  private CONFIGURATION_TYPE = 'notification';
  private DEFAULT_DOMAIN = '@state.mn.us';

  public configuration: NotificationsConfiguration;

  public isConfigurationLoading = true;
  public isSaving = false;
  public error = null;

  constructor(private configurationService: ConfigurationService,
              private connectivityService: ConnectivityService,
              private messageService: MessageService) { }

  ngOnInit() {
    if (!this.connectivityService.isOnline()) {
      this.error = 'You are offline. The Notifications Configuration cannot be retrieved in offline mode.';
      this.isConfigurationLoading = false;
    } else {
      this.getConfiguration();
    }
  }

  getConfiguration() {
    this.configurationService.get(this.CONFIGURATION_TYPE).subscribe(
      configuration => {
        if (configuration && typeof configuration !== 'string') {
          this.configuration = configuration;
          this.removeDomain();
        } else {
          this.configuration = {
            noncomcontact: null,
            comcontact: null
          };
        }
        this.isConfigurationLoading = false;
      },
      error => {
        if (error.status === 404 && error.error && error.error.message === 'Notification Configuration is Missing') {
          this.configuration = {
            noncomcontact: null,
            comcontact: null
          };
        } else {
          this.error = error;
        }
        this.isConfigurationLoading = false;
      }
    );
  }

  removeDomain(): void {
    if (this.configuration) {
      if (this.configuration.comcontact) {
        const atIndex = this.configuration.comcontact.lastIndexOf('@');
        if (atIndex > -1) {
          this.configuration.comcontact = this.configuration.comcontact.slice(0, atIndex);
        }
      }
      if (this.configuration.noncomcontact) {
        const atIndex = this.configuration.noncomcontact.lastIndexOf('@');
        if (atIndex > -1) {
          this.configuration.noncomcontact = this.configuration.noncomcontact.slice(0, atIndex);
        }
      }
    }
  }

  addDomain(): void {
    this.configuration.comcontact += this.DEFAULT_DOMAIN;
    this.configuration.noncomcontact += this.DEFAULT_DOMAIN;
  }

  save(): void {
    this.messageService.clear();
    this.isSaving = true;
    if (this.isValid()) {
      this.addDomain();
      this.configurationService.update(this.CONFIGURATION_TYPE, this.configuration).subscribe(
        () => {
          this.messageService.add({ severity: Severity.SUCCESS, value: 'The configuration has been saved.' });
          this.isSaving = false;
        },
        error => {
          this.messageService.add({ severity: Severity.ERROR, value: 'The configuration failed to save due to: ' + error.message });
          this.isSaving = false;
        }
      );
      this.removeDomain();
    } else {
      this.messageService.add({ severity: Severity.ERROR, value: 'All required fields must be filled in before saving.' });
    }
    window.scrollTo(0, 0);
  }

  isValid(): boolean {
    return this.configuration && this.configuration.comcontact && this.configuration.comcontact !== ''
      && this.configuration.noncomcontact && this.configuration.noncomcontact !== '';
  }
}
